import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Field, change } from 'redux-form'
import SelectField from 'forms/shared/fields/select'
import RadioButton from 'components/shared/form/radio-button'
import CheckboxField from 'forms/shared/fields/checkbox'
import { DAYS, SAME_DAYS, PER_30_MINUTES_DROPDOWN } from 'constants/date-time';
import { FORM_ERROR_CLASS, INPUT_ERROR_CLASS, MERCHANT_FORM_LABEL } from 'constants/css-style'

const Openning = ({ dispatch, form, isDifferentSchedule = true }) => {
  const [scheduleDays, setScheduleDays] = useState(DAYS)
  const [differentSchedule, setDifferentSchedule] = useState(true)

  const handleAction = () => {
    setScheduleDays(!differentSchedule ? DAYS : SAME_DAYS)
    setDifferentSchedule(!differentSchedule)
  }

  useEffect(() => {
    setDifferentSchedule(isDifferentSchedule)
  }, [isDifferentSchedule])

  useEffect(() => {
    dispatch(change(form, 'differentSchedule', differentSchedule))
    setScheduleDays(differentSchedule ? DAYS : SAME_DAYS)
  }, [differentSchedule])

  const renderScheduleDay = () => (
    scheduleDays.map((scheduleDay, index) => (
      <div key={index} className="flex items-center">
        <label className="w-1/5 py-3">{scheduleDay}</label>
        <Field
          name={`schedulesOpen[${differentSchedule ? index : index + 4}][start_time]`}
          label={''}
          placeholder="Start time"
          labelClassName={MERCHANT_FORM_LABEL}
          groupClassName="my-3 w-1/5 px-2"
          options={PER_30_MINUTES_DROPDOWN}
          inputClassName={'select text-xs'}
          inputErrorClassName={INPUT_ERROR_CLASS}
          errorClassName={FORM_ERROR_CLASS}
          component={SelectField}
        />
        <label className="w-1/12 py-3 text-center">until</label>
        <Field
          name={`schedulesOpen[${differentSchedule ? index : index + 4}][end_time]`}
          label={''}
          placeholder="End time"
          labelClassName={MERCHANT_FORM_LABEL}
          groupClassName="my-3 w-1/5 px-2"
          options={PER_30_MINUTES_DROPDOWN}
          inputClassName={'select text-xs'}
          inputErrorClassName={INPUT_ERROR_CLASS}
          errorClassName={FORM_ERROR_CLASS}
          component={SelectField}
        />
        <Field
          type={'checkbox'}
          styles={{ borderRadius: '9999px' }}
          name={`schedulesOpen[${differentSchedule ? index : index + 4}][closed]`}
          label={'Closed'}
          groupClassName="my-3 w-1/5"
          labelClassName="text-primary-black text-base"
          inputErrorClassName={INPUT_ERROR_CLASS}
          errorClassName={FORM_ERROR_CLASS}
          component={CheckboxField}
        />
      </div>
    ))
  )

  return (
    <div className="openning pb-6">
      <p className="font-bold mb-3 text-xl">Opening Hours</p>
      <div className="schedule flex mb-2">
        <div className="mr-6">
          <RadioButton checked={!differentSchedule} action={handleAction} label="Same availability from Monday To Friday" name="schedule" />
        </div>
        <div className="mr-6">
          <RadioButton checked={differentSchedule} action={handleAction} label="Different Schedule" name="schedule" />
        </div>
      </div>
      <div className="schedule-day w-3/4">
        {renderScheduleDay()}
      </div>
    </div>
  )
}

Openning.propTypes = {
  dispatch: PropTypes.func,
  form: PropTypes.string,
  isDifferentSchedule: PropTypes.bool
}

const mapStateToProps = ({ venue }) => {
  return {
    isDifferentSchedule: venue.details.differentSchedule
  }
}

export default connect(mapStateToProps)(Openning)
